import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {Button, Input, Spacer, Toggle, CheckBox, RadioBox } from "@dspworkplace/ui";

export default function DSPSettings({  initialValues = false, onSubmit }) {
    const { register, handleSubmit, errors, reset, watch } = useForm();
    const [loading, setLoading] = useState(false);
    const [showBlockTiePunchInToGeofence, setShowBlockTiePunchInToGeofence] = useState(
        initialValues?.tiePunchInToGeofence === true || initialValues?.tiePunchInToGeofence === "true"
    );
    const [enableThisAccount, setEnableThisAccount] = useState(
        initialValues?.enabled ?? false
    );
    const [showBlockTiePunchOutToGeofence, setShowBlockTiePunchOutToGeofence] = useState(
        initialValues?.tiePunchOutToGeofence === true || initialValues?.tiePunchOutToGeofence === "true"
    );
    useEffect(() => {
        if (initialValues) reset(initialValues);
    }, [initialValues]);

    const handleSave = async (data) => {
        data.credentials = {};
        data.credentials.username = data.clientId;
        data.credentials.password = data.clientSecret;
        data.doNotAllowPunchInBeforeScheduleStartTime =
            (data.doNotAllowPunchInBeforeScheduleStartTime === "true" ||
                data.doNotAllowPunchInBeforeScheduleStartTime === true) ??
            false;
        // punch in geofence
        data.tiePunchInToGeofence =
            (data.tiePunchInToGeofence === "true" || data.tiePunchInToGeofence === true) ?? false;
        if (data.tiePunchInToGeofence === false) {
            data.tiePunchInToGeofence = data.tiePunchInToGeofenceOptions;
        }
        data.allowAndDoNotAllowPunchInOutSideGeofence = parseInt(data.allowAndDoNotAllowPunchInOutSideGeofence);
        // punch out geofence
        data.tiePunchOutToGeofence =
            (data.tiePunchOutToGeofence === "true" || data.tiePunchOutToGeofence === true) ?? false;
        if (data.tiePunchOutToGeofence === false) {
            data.tiePunchOutToGeofence = data.tiePunchOutToGeofenceOptions;
        }
        data.allowAndDoNotAllowPunchOutOutSideGeofence = parseInt(data.allowAndDoNotAllowPunchOutOutSideGeofence);
        delete data.clientId;
        delete data.clientSecret;

        setLoading(true);

        onSubmit(data).catch((err) => setLoading(false));
    }

    return (
        <section>
            <form onSubmit={handleSubmit(handleSave)}>
                <input type="hidden" name="id" ref={register} autoComplete="off" />
                <input type="hidden" value="DSP" name="integration_type" ref={register} autoComplete="off" />
                <Input
                    ref={register({ required: true })}
                    name="name"
                    label="Account name"
                    Required={true}
                    invalid={errors && errors.name}
                    error={errors && errors.name && "Required field"}
                    autoComplete="off"
                    help={"You can only have one DSP Integration account"}
                />
                <Spacer bottom={3} />
                <Toggle
                    ref={register()}
                    on={enableThisAccount}
                    name="enabled"
                    singleText="Enable this account"
                />
                <Spacer bottom={3} />
                <Toggle
                    ref={register}
                    name="syncTimeOff"
                    // help="If this is enabled, the system will automatically fetch ADP punch data."
                    singleText="Enable TimeOff Sync"
                />
                <Spacer bottom={5} />
                <CheckBox
                    ref={register()}
                    name="doNotAllowPunchInBeforeScheduleStartTime"
                    options={[
                        { value: true, label: 'Do not allow "Punch In" before scheduled start time' },
                    ]}
                />
                <Spacer bottom={5} />
                <CheckBox
                    ref={register()}
                    name="tiePunchInToGeofence"
                    options={[{ value: true, label: 'Tie "Punch in" to geofence' }]}
                    onClick={(event) => {
                        setShowBlockTiePunchInToGeofence(event.target.checked);
                    }}
                />
                {showBlockTiePunchInToGeofence && (
                    <div style={{ marginLeft: "35px" }}>
                        <Spacer bottom={3} />
                        <CheckBox
                            ref={register({ required: true })}
                            name="tiePunchInToGeofenceOptions"
                            options={[
                                { value: "station", label: "Station" },
                                { value: "parking_lot", label: "Parking lot" },
                            ]}
                            Required={true}
                            invalid={errors && errors.tiePunchInToGeofenceOptions}
                            error={
                                errors &&
                                errors.tiePunchInToGeofenceOptions &&
                                "Please select at least one option."
                            }
                        />
                        <Spacer bottom={3} />
                        <RadioBox
                            ref={register({ required: true })}
                            name="allowAndDoNotAllowPunchInOutSideGeofence"
                            options={[
                                { label: 'Allow "Punch in" outside geofence but notify management', value: 1 },
                                { label: 'Do not allow "Punch in" outside of geofence', value: 2 },
                            ]}
                            Required={true}
                            invalid={errors && errors.allowAndDoNotAllowPunchInOutSideGeofence}
                            error={
                                errors &&
                                errors.allowAndDoNotAllowPunchInOutSideGeofence &&
                                "Please select at least one option."
                            }
                        />
                    </div>
                )}
                <Spacer bottom={5} />
                <CheckBox
                    ref={register()}
                    name="tiePunchOutToGeofence"
                    options={[{ value: true, label: 'Tie "Punch out" to geofence' }]}
                    onClick={(event) => {
                        setShowBlockTiePunchOutToGeofence(event.target.checked);
                    }}
                />
                {showBlockTiePunchOutToGeofence && (
                    <div style={{ marginLeft: "35px" }}>
                        <Spacer bottom={3} />
                        <CheckBox
                            ref={register({ required: true })}
                            name="tiePunchOutToGeofenceOptions"
                            options={[
                                { value: "station", label: "Station" },
                                { value: "parking_lot", label: "Parking lot" },
                            ]}
                            Required={true}
                            invalid={errors && errors.tiePunchOutToGeofenceOptions}
                            error={
                                errors &&
                                errors.tiePunchOutToGeofenceOptions &&
                                "Please select at least one option."
                            }
                        />
                        <Spacer bottom={3} />
                        <RadioBox
                            ref={register({ required: true })}
                            name="allowAndDoNotAllowPunchOutOutSideGeofence"
                            options={[
                                { label: 'Allow "Punch out" outside geofence but notify management', value: 1 },
                                { label: 'Do not allow "Punch out" outside of geofence', value: 2 },
                            ]}
                            Required={true}
                            invalid={errors && errors.allowAndDoNotAllowPunchOutOutSideGeofence}
                            error={
                                errors &&
                                errors.allowAndDoNotAllowPunchOutOutSideGeofence &&
                                "Please select at least one option."
                            }
                        />
                    </div>
                )}
                <Spacer bottom={5} />
                <Button type="primary" disabled={loading}>
                    {!loading ? "Save" : "Saving..."}
                </Button>
            </form>
        </section>
    );
}